<template>
  <v-card
    class="video-card layout-vertical mb-7"
    outlined
    style="background-color: transparent; border: none"
  >
    <router-link
      :to="{
        name: 'videoFromTheme',
        params: {
          id: video['@id'].substring(12),
          idTheme: theme ? theme.id : video.theme.id,
        },
      }"
    >
     <div class="video-card__img-container">
      <v-img
        height="150"
        :src="apiUrl + '/files/uploads/video/posterFile/' + video.poster"
      >
          <v-avatar color="white">
            <v-img contain :src=themeLogo />
          </v-avatar>
      </v-img>
      <div v-if="seen" class="video-card__seen"><span class="v-icon mdi mdi-check-bold"/></div>
      </div>
      <div class="video-card__content">
      <v-card-title
        class="pa-0 mt-5 d-flex align-items-stretch" data-toggle="tooltip" data-placement="top" v-bind:title="video.title"
      >
         <p class="truncate">{{ video.title }} {{ $route.params.id }}</p>
      </v-card-title>
      <v-card-subtitle style="margin-top:1px" class="title-truncate pa-0 mt-1 d-flex align-items-center">
          <a target="_blank" :href="video.partner ? video.partner.url : 'https://www.tellmegenius.io/'"> 
            <v-avatar size="20" color="white" >
              <v-img contain :src=partnerLogo />
            </v-avatar>
          </a>
          <span class="caption ml-1 font-weight-thin"><a target="_blank" style="color:inherit;text-decoration:inherit" :href="video.partner ? video.partner.url : 'https://www.tellmegenius.io/'"> {{ video.partner ? video.partner.name : "TellMeGenius" }} </a> | {{getViews(video)}} {{$t('video.views')}}</span> 
      </v-card-subtitle>
      </div>
    </router-link>

    <!-- collapse description -->
    <v-card-actions @click="show = !show" class="py-0 pl-0">
      <v-btn id="overDetail" color="#363738" style="background-color: transparent; font-weight:800;" class="px-0" text>{{$t('common.detail')}}</v-btn>

      <v-spacer></v-spacer>

      <v-btn icon>
        <v-icon>{{ show ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
      </v-btn>
    </v-card-actions>

    <v-expand-transition>
      <div v-show="show">
        <v-card-text class="pt-0 pb-4 px-0">
          <div>
            {{ video.description }}
          </div>
        </v-card-text>
      </div>
    </v-expand-transition>
  </v-card>
</template>



<script>
import moment from "moment";
import { getThemeLogoUrl } from '@/core/utils/theme';
import { getReadableViews } from '@/core/utils/video';
import { getPartnerLogoUrl } from '@/core/utils/partner';
import {userVideoSeen} from '@/core/utils/user';
import {mapGetters} from "vuex";
import '@/assets/sass/components/video/_video-card.scss';
// TODO: Supprimer ce composant ? (remplacé par video/videoCard.vue)
export default {
  name: "video-theme-card",
  data: () => ({
    show: false,
  }),
  props: {
    video: Object,
    theme: Object, // Optionel (uniquement si video.theme est undefined)
  },
  methods : {
    getViews(video) {return getReadableViews(video);}
  },
  filters: {
    moment: function (date) {
      return moment(date).format("DD/MM/YY");
    },
  },
  computed: {
    ...mapGetters(["layoutConfig","currentUser"]),
    defaultLogo() {
      return process.env.BASE_URL + this.layoutConfig("self.nologo");
    },
    partnerLogo : function () {
      return getPartnerLogoUrl(this.video.partner , process.env.BASE_URL + this.layoutConfig("self.logo"));
    },
    themeLogo : function () {
      return getThemeLogoUrl(this.theme,  process.env.BASE_URL + this.layoutConfig("self.nologo"));
    },
    seen: function () {
      return userVideoSeen(this.currentUser, this.video);
    },
    apiUrl() {
      return process.env.VUE_APP_API;
    },
  },
};
</script>
